import axios from 'axios'
import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints'

const {
  endpoints: {
    users: { addressUrl },
  },
} = config

const getUrl = (userId) => addressUrl.replace(':userId', userId || '')

/**
 * Get address from user.
 *
 * @param {String} params.userId Id of the user in the database
 */
const get = (userId) => axios.get(getUrl(userId), { headers: getHeaders(true) })

/**
 * Update address from user.
 *
 * @param {String} data.userId Id of the user in the database
 * @param {String} data.address Address data to add
 */
const update = (userId, address) => axios.put(getUrl(userId), { address }, { headers: getHeaders(true) })

export default { get, update }
